const appointReducer = (state = {}, action) => {
  switch (action.type) {
    default: {
      return state;
    }
  }
}

export default appointReducer;


// WEBPACK FOOTER //
// ./src/views/Appointment/state/reducer.js